@if (activeConfirmation(); as confirmation) {
  <div class="sx-modal-backdrop sx-modal-backdrop--elevated">
    <div
      class="sx-modal sx-card sx-confirm-modal"
      [class.sx-confirm-modal--danger]="confirmation.confirmKind === 'danger'"
      [class.sx-confirm-modal--primary]="confirmation.confirmKind === 'primary'"
      [class.sx-confirm-modal--lg]="confirmation.size === 'lg'"
      role="dialog"
      aria-modal="true"
      [attr.aria-labelledby]="'sx-confirm-title'"
      (click)="$event.stopPropagation()"
    >
      @if (confirmation.showClose) {
        <button
          type="button"
          class="sx-confirm-modal__close"
          aria-label="Close"
          (click)="onCancel()"
        >
          <lucide-icon [img]="icons.close" class="h-4 w-4"></lucide-icon>
        </button>
      }

      <div class="sx-confirm-modal__hero">
        <span
          class="sx-confirm-modal__icon"
          [class.sx-confirm-modal__icon--danger]="confirmation.confirmKind === 'danger'"
          [class.sx-confirm-modal__icon--primary]="confirmation.confirmKind === 'primary'"
          aria-hidden="true"
        >
          @if (confirmation.confirmKind === 'danger') {
            <lucide-icon [img]="icons.alert"></lucide-icon>
          } @else {
            <lucide-icon [img]="icons.info"></lucide-icon>
          }
        </span>

        <h3 id="sx-confirm-title" class="sx-confirm-modal__title">{{ confirmation.title }}</h3>
        <p class="sx-confirm-modal__message">{{ confirmation.message }}</p>

        @if (confirmation.reasonInput; as reasonInput) {
          <label class="sx-confirm-modal__reason">
            <span class="sx-confirm-modal__reason-label">{{ reasonInput.label || 'Reason (optional)' }}</span>
            <textarea
              class="sx-confirm-modal__reason-input"
              rows="3"
              [placeholder]="reasonInput.placeholder || 'Leave blank to use the default'"
              [ngModel]="reasonText()"
              (ngModelChange)="reasonText.set($event)"
            ></textarea>
          </label>
        }
      </div>

      <div class="sx-confirm-modal__actions">
        <button
          type="button"
          class="sx-confirm-modal__btn sx-confirm-modal__btn--secondary"
          (click)="onCancel()"
        >
          {{ confirmation.cancelLabel }}
        </button>
        <button
          type="button"
          class="sx-confirm-modal__btn"
          [class.sx-confirm-modal__btn--danger]="confirmation.confirmKind === 'danger'"
          [class.sx-confirm-modal__btn--primary]="confirmation.confirmKind === 'primary'"
          (click)="onConfirm()"
        >
          {{ confirmation.confirmLabel }}
        </button>
      </div>
    </div>
  </div>
}
